import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-house",
    templateUrl: "./go-house.component.html"
})


export class GoHouseComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;

    constructor() {
        super(GO_COMPONENTS.HOUSE);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-house/go-house.component.ts